import { api, getCnpjGestor, getEmailLogin } from '@/services';

export interface HistoricoUploadItem {
  ID_Upload: string;
  NomeArquivo: string;
  DataHoraUpload: string;
  Origem: string;
  Status: string;
  StatusUpload: string;
  Descompactados: string;
  Aguardando: string;
  Processando: string;
  Processados: string;
  ComErro: string;
  CaminhoArquivo?: string;
  TipoArquivo?: string;
}

export interface HistoricoUploadResponse {
  totalItens: number;
  data: {
    documentos: HistoricoUploadItem[];
    revisao: HistoricoUploadItem[];
  };
  status: { resultado: boolean; mensagem: string };
}

export async function fetchHistoricoUpload(
  periodo: number,
  cnpjContribuinte: string
): Promise<HistoricoUploadResponse> {
  return api.get<HistoricoUploadResponse>(
    `Arq/HistoricoUpload2/${periodo}?cnpj_contribuinte=${cnpjContribuinte}`,
    { headers: { CNPJ_Gestor: getCnpjGestor(), email_login: getEmailLogin() } }
  );
}

export async function reprocessarXML(idUpload: string): Promise<void> {
  return api.post(
    'Arq/ReprocessarXMLPorId',
    { idUpload },
    { headers: { CNPJ_Gestor: getCnpjGestor() } }
  );
}

export async function priorizar(idUpload: string): Promise<void> {
  return api.post(
    'uploads/priorizar',
    { ID_Upload: idUpload },
    { headers: { CNPJ_Gestor: getCnpjGestor() } }
  );
}

export async function cancelarProcessamento(idUpload: string): Promise<void> {
  return api.post(
    'Arq/CancelarProcessamento',
    { IDUpload: Number(idUpload) },
    { headers: { CNPJ_Gestor: getCnpjGestor() } }
  );
}
